<template>
  <div class=" footer footMain" style="text-align:center">
    <img :src="footerImg">
  
  <div class="links">
    <p>
      <a href="/main/about.htm">关于我们</a>
      |
      <a href="/main/copyright.htm">版权声明</a>
      |
      <a href="/main/lineService.htm">在线客服</a>
      |
      <a href="/main/help.htm">常见问题</a>
      |
      <a href="/main/readme.htm">积分说明</a>
      |
      <a href="/main/partnership.htm">商务合作</a>
      |
      <a href="/main/contact.htm">联系我们</a>
    </p>
    <p>
      <a href="http://www.miitbeian.gov.cn" target="_blank">京ICP备10214027号-3</a> 京网文(2015)0513-193号 增值电信业务经营许可证沪B2-20090110
    </p>
    <p>
      © 2018
      <span>中文在线</span> 书香中国为中文在线旗下网站未经许可严禁转载
    </p>
  </div> 
  </div>
</template>

<script>
export default {
  name: "footer",
  props: {},
   data() {
    return {
     footerImg:require("../../assets/img/pc/3.jpg")
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.footer{
    width: 100%;
    height: auto;
    position: relative;
    >img{
      width: 100%;
      position: absolute;
      top: 0.2rem;
      left: 0;
      z-index: 1;
    }
}
.footMain{
  color: #1B1B1B;
  font-size: 0.2rem;
  height: auto;
  min-height: 11rem;
  padding-top:0.78rem ;
  a{
      color: #1B1B1B;
  }
  p{
    line-height: 0.4rem;
  }
  .links{
    position: absolute;
    left: 0;
    bottom: -1rem;
    width: 100%;
    z-index: 2;
  }
}
</style>
